import { useQuery } from "@tanstack/react-query";
import { fetchPedidoById, fetchPedidos } from "./api";

export function usePedidos({ origin, status, statusDate, search }) {
  return useQuery({
    queryKey: ["pedidos", { origin, status, statusDate, search }],
    queryFn: () => fetchPedidos({ origin, status, statusDate, search }),
  });
}

export function usePedido(id) {
  return useQuery({
    queryKey: ["pedido", id],
    queryFn: () => fetchPedidoById(id),
    enabled: Boolean(id),
  });
}
